import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class PendingNavigationService {
  private pendingRoute: string | null = null;

  setPendingRoute(route: string): void {
    this.pendingRoute = route;
  }

  consumePendingRoute(): string | null {
    const route = this.pendingRoute;
    this.pendingRoute = null;
    return route;
  }
}
